import { render, staticRenderFns } from "./LaudoTecnicoDescricao.vue?vue&type=template&id=8550d3bc&scoped=true"
import script from "./LaudoTecnicoDescricao.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoDescricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8550d3bc",
  null
  
)

export default component.exports